var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopnavSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41243 3.5C6.1467 3.5 3.5 6.1467 3.5 9.41243C3.5 12.6782 6.1467 15.3249 9.41243 15.3249C10.9797 15.3249 12.4033 14.716 13.462 13.7203C14.6097 12.641 15.3249 11.1109 15.3249 9.41243C15.3249 6.14676 12.6775 3.5 9.41243 3.5ZM2 9.41243C2 5.31828 5.31828 2 9.41243 2C13.5058 2 16.8249 5.31822 16.8249 9.41243C16.8249 11.2713 16.1399 12.971 15.0101 14.2716L17.3285 16.7361C17.6123 17.0378 17.5978 17.5125 17.2961 17.7963C16.9944 18.0801 16.5198 18.0656 16.236 17.7639L13.9174 15.2992C12.669 16.2558 11.1065 16.8249 9.41243 16.8249C5.31828 16.8249 2 13.5066 2 9.41243Z",
    fill: "#1A1926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33682 11C6.12085 10.5454 6 10.0368 6 9.5C6 8.22684 6.67979 7.11245 7.69621 6.5",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.33682 11C6.12085 10.5454 6 10.0368 6 9.5C6 8.22684 6.67979 7.11245 7.69621 6.5",
    stroke: "#1A1926"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopnavSearch);
export default __webpack_public_path__ + "static/media/topnav-search.9bd77f3131cf08bedd98eb8d5f6c022b.svg";
export { ForwardRef as ReactComponent };